import React, { useState } from 'react';
import './ChatInput.css';

function ChatInput({ onSend }) {
  const [value, setValue] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    const trimmed = value.trim();
    if (trimmed && onSend) {
      onSend(trimmed);
      setValue('');
    }
  }

  return (
    <form className="chat-input-form" onSubmit={handleSubmit}>
      <input
        type="text"
        className="chat-input-field"
        placeholder="Type a message..."
        value={value}
        onChange={function (e) {
          setValue(e.target.value);
        }}
        aria-label="Message"
      />
      <button type="submit" className="chat-input-send" aria-label="Send message">
        Send
      </button>
    </form>
  );
}

export default ChatInput;
